import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { t } from '../../i18n/translate.js';
import '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import Input from '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import '../../components/LoadingSpinner/LoadingSpinner.module.scss.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import '../../components/Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import styles from './AccessToken.module.scss.js';

var SmsStep = function SmsStep(_ref) {
  var setSmsToken = _ref.setSmsToken,
    smsToken = _ref.smsToken;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.intro
  }, /*#__PURE__*/React.createElement("p", {
    className: classNames(styles.smsCodeDescription, 'secondary')
  }, t("MPLIB_ACCESS_TOKEN_STEP_2_DESCRIPTION")), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.verifyCodeTitle)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.number)
  }, /*#__PURE__*/React.createElement("p", null, "2")), t("MPLIB_ACCESS_TOKEN_STEP_2")), /*#__PURE__*/React.createElement(Input, {
    onChange: function onChange(value) {
      return setSmsToken(value);
    },
    placeholder: t("MPLIB_SMSTOKEN_TITLE"),
    value: smsToken,
    dataTestId: "tokenInput",
    className: styles.passwordInput,
    autoComplete: "one-time-code",
    focus: true
  }));
};
SmsStep.propTypes = {
  setSmsToken: PropTypes.func.isRequired,
  smsToken: PropTypes.string.isRequired
};

export { SmsStep as default };
